(function () {
  const questions = document.querySelectorAll(".faq-question");

  questions.forEach((question) => {
    question.addEventListener("click", handleQuestionClick);
  });

  function handleQuestionClick() {
    const parent = this.parentElement;
    const answer = parent.querySelector(".faq-answer");

    // Tıklanan eleman zaten açıksa kapat
    if (answer.classList.contains("opened")) {
      answer.classList.remove("opened");
      parent.classList.remove("active");
      answer.style.height = 0 + "px";
      return;
    }

    // Açık olan başka bir eleman varsa kapat
    const openedAnswer = document.querySelector(".faq-answer.opened");
    if (openedAnswer) {
      openedAnswer.classList.remove("opened");
      openedAnswer.parentElement.classList.remove("active");
      openedAnswer.style.height = 0 + "px";
    }

    // Tıklanan elemanı aç
    answer.classList.add("opened");
    parent.classList.add("active");
    answer.style.height = answer.scrollHeight + "px";
  }
})();